import index from './searchBar'

export default index